<template>
  	<div id="app">
		<app-header v-if="$route.path.indexOf('/task/list') < 0"></app-header>
        <template v-if="$route.path.indexOf('/task/list') < 0">
            <div id="wrapper" class="app-sidebar-right">
                <app-sidebar></app-sidebar>
                <router-view></router-view>
            </div>
        </template>
        <template v-else>
            <router-view></router-view>
        </template>
  	</div>
</template>

<script>
	import "@babel/polyfill";
    import Header from '@/components/partials/Header';    
    import Footer from '@/components/partials/Footer';
    import Sidebar from '@/components/partials/Sidebar';
	import EventBus from '../../frontend/src/components/event-bus';
	var contex;
	export default {
		components: {
            'app-header': Header,
            'app-footer': Footer,
            'app-sidebar': Sidebar,
        },
		name: 'App',
		data: () => ({
            showHeader: true,
        }),
        beforeMount: function () {
            contex = this;
        },
        mounted: function() {
        },

        methods : {

        }
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue